// custom-slider.js
$(document).ready(function () {
  $('.custom-slideshow-slider').slick({
    slidesToShow: 1, 
    slidesToScroll: 1, 
    autoplay: false, 
    // autoplaySpeed: 5000, 
    arrows: false, 
    dots: true, 
  });
});
// $('.magic-validation').click(function () {
//    $(this).parents('.magin-code-v1-box').find('span.error').hide();
  
//   var magic=$('input.your-code').val();
//   if(magic.length > 5){
//     var magic_codes=$('.magic_codes').val();
//     if(magic_codes.indexOf(magic) !== -1){
//       var next=$(this).data('next');
//       $('.magic-code').hide();
//       $('.magic-code-v2').show();
//       $('.magic-placeholder').val(magic);
//     }else{
//      $(this).parents('.magin-code-v1-box').find('span.error').show();
//     }
//   }else{
//      $(this).parents('.magin-code-v1-box').find('span.error').show();
    
//   }
// });
$('.magic-code-continue').click(function () {
  $('.magic-code').hide();
  $('.magic-code-v3').show();
});

/* ============================================================
 * Click & Mix — Subscribe & Save subscription price display
 * ------------------------------------------------------------
 * v6: re-apply Loop's volume discount, and recompute when the
 * pack size changes without a click.
 *
 * v4 applied ONLY the 15% selling-plan discount, on the stated
 * premise that Loop's FIXED "N-Pack" discount does not apply to
 * subscriptions. That premise is wrong. All three ROW tiers are
 * configured purchaseType: SUBSCRIPTION — they apply to
 * subscriptions and to nothing else. Verified against the cart:
 * a 20-pack subscription line comes back at 79700 (797.00 kr)
 * with discount LPBNDL8j5w4 for 20600, not the 100300 v4 showed.
 *
 * Because v4 omitted it, the page advertised subscribe at 502 kr
 * (10-pack) and 1,003 kr (20-pack) against one-time 490 / 890 —
 * i.e. subscribing looked more expensive than not subscribing,
 * while the cart charged 401.50 / 797.00 all along.
 *
 * Math, in the order the cart applies it:
 *   1. per pack  = round(flavor_price × (1 − sellingPlan%))
 *   2. line      = per_pack × packSize
 *   3. line      = line − bundle volume discount (FIXED, in the
 *                  bundle's master currency — FX-convert it)
 * Per-pack is rounded at step 1 because Shopify rounds the
 * per-unit selling-plan allocation before totalling the line.
 *
 * Flavor pack price comes from /products/{handle}.js for one of
 * the bundle's flavor products (Loop tells us the handles). Falls
 * back to the bundle variant price / packSize if the fetch fails.
 *
 * LOAD RACE (v6). packSize is read when the calculation runs. On
 * load there are two actors and no guaranteed order: the Loop
 * bundle fetch resolving, and ClickAndMixBundle.init() restoring
 * the saved pack size from localStorage. If the fetch wins, the
 * price is computed against the default 10-Pack and then never
 * recomputed when init() silently switches to 5 or 20 — it sets
 * the class, it does not fire a click. A returning visitor whose
 * saved size is 20 then sees the 10-pack subscription price
 * (402 kr) beside the 20-pack one-time price (890 kr), and the
 * cart charges 797 kr. Under-advertising, so worse than the bug
 * v5 fixed. The observer below closes it: any change to the pack
 * buttons' classes re-runs the calculation, debounced.
 * ============================================================ */
(function () {
  if (typeof customElements === 'undefined') return;

  function activeCurrency() {
    return (window.shopSettings && window.shopSettings.isoCode) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      null;
  }
  function isBase() { return activeCurrency() === 'SEK'; }
  function fxRateFromBase() {
    if (isBase()) return 1;
    var r = window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
    if (r == null) return null;
    var n = parseFloat(r);
    return isFinite(n) && n > 0 ? n : null;
  }

  // Cache the localised flavor pack price (assumes all flavor variants
  // share the same per-pack price, which matches the current store config).
  var flavorPriceCache = null;
  var flavorPricePromise = null;
  function getFlavorPriceCents(bundle) {
    if (flavorPriceCache != null) return Promise.resolve(flavorPriceCache);
    if (flavorPricePromise) return flavorPricePromise;
    var products = bundle && bundle.products;
    if (!products || !products.length) return Promise.resolve(null);
    var idx = 0;
    function tryNext() {
      if (idx >= products.length) return null;
      var handle = products[idx++].handle;
      if (!handle) return tryNext();
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && p.variants && p.variants[0] && typeof p.variants[0].price === 'number') {
            flavorPriceCache = p.variants[0].price; // cents, active ccy
            return flavorPriceCache;
          }
          return tryNext();
        })
        .catch(function () { return tryNext(); });
    }
    flavorPricePromise = Promise.resolve().then(tryNext);
    return flavorPricePromise;
  }

  customElements.whenDefined('product-form-clicknmix').then(function (cls) {
    if (!cls || !cls.prototype) return;

    cls.prototype.updateSubscriptionOptions = function () {
      if (!this.bundle) return;
      var packSize = this.packSize;
      if (isNaN(packSize)) return;

      var sellingPlanDiscount =
        this.bundle.sellingPlans &&
        this.bundle.sellingPlans[0] &&
        this.bundle.sellingPlans[0].discounts &&
        this.bundle.sellingPlans[0].discounts[0];
      if (!sellingPlanDiscount) return;

      // Loop's volume discount for the selected pack size. Same getter
      // onSubmitHandler uses to build the bundle transaction, so display
      // and cart cannot drift apart.
      var bundleDiscount = this.bundleDiscount;

      var section = this.closest('section');

      getFlavorPriceCents(this.bundle).then(function (perPackCents) {
        if (perPackCents == null) {
          // Fallback: use the bundle variant price / packSize.
          var variantSelector = section && section.querySelector('variant-radios, variant-selects');
          var currentVariant = variantSelector && variantSelector.currentVariant;
          if (!currentVariant) return;
          perPackCents = currentVariant.price / packSize;
        }

        // 1. Selling-plan discount, per pack.
        var perPackAfterCents;
        if (sellingPlanDiscount.type === 'FIXED') {
          // FIXED is stored in master currency (SEK). FX-convert if non-base.
          var spRate = fxRateFromBase();
          var spDeductCents = spRate != null ? sellingPlanDiscount.value * spRate * 100 : 0;
          perPackAfterCents = Math.round(perPackCents - spDeductCents / packSize);
        } else {
          perPackAfterCents = Math.round(perPackCents * (1 - 0.01 * sellingPlanDiscount.value));
        }
        if (perPackAfterCents < 0) perPackAfterCents = 0;

        // 2. Line subtotal.
        var finalLinePrice = perPackAfterCents * packSize; // cents

        // 3. Loop volume discount, applied to the whole line.
        if (bundleDiscount) {
          var bundleDeductCents;
          if (bundleDiscount.type === 'FIXED') {
            var bRate = fxRateFromBase();
            bundleDeductCents = bRate != null ? bundleDiscount.value * bRate * 100 : 0;
          } else {
            bundleDeductCents = finalLinePrice * 0.01 * bundleDiscount.value;
          }
          finalLinePrice = Math.round(finalLinePrice - bundleDeductCents);
          if (finalLinePrice < 0) finalLinePrice = 0;
        }

        var finalPrice = finalLinePrice / packSize; // cents per pack

        $(section)
          .find('.subscriptionprice.desktoponly')
          .html(
            Shopify.formatMoney(finalLinePrice) +
              ' per month <br/>[' +
              Shopify.formatMoney(finalPrice) +
              ' per pack]'
          );
      });
    };

    function refreshAll() {
      document.querySelectorAll('product-form-clicknmix').forEach(function (el) {
        if (typeof el.updateSubscriptionOptions === 'function' && el.bundle) {
          try { el.updateSubscriptionOptions(); } catch (_) {}
        }
      });
    }

    // Recompute whenever the active pack button changes, however it
    // changed — user click, or init() restoring localStorage. Debounced
    // because selecting flavors toggles classes in the same subtree.
    var refreshTimer = null;
    function scheduleRefresh() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshAll, 50);
    }

    if (typeof MutationObserver !== 'undefined') {
      var packContainer =
        document.querySelector('.choose-pack') ||
        document.querySelector('click-and-mix-bundle');
      if (packContainer) {
        new MutationObserver(scheduleRefresh).observe(packContainer, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true,
        });
      }
    }

    refreshAll();
  });
})();
